import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */
import { useState, useRef, useEffect } from 'react';
import FocusTrap from 'focus-trap-react';
const withFocusTrap = (shouldTrapFocus = () => true, options = {}) => WrappedComponent => {
  function WithFocusTrap(props) {
    const $ = _c(11);
    let t0;
    if ($[0] !== props) {
      t0 = shouldTrapFocus(props);
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    const [isFocusTrapped, setIsFocusTrapped] = useState(t0);
    const rootElement = useRef(null);
    let t1;
    let t2;
    if ($[2] !== props) {
      t1 = () => {
        setIsFocusTrapped(shouldTrapFocus(props));
      };
      t2 = [props];
      $[2] = props;
      $[3] = t1;
      $[4] = t2;
    } else {
      t1 = $[3];
      t2 = $[4];
    }
    useEffect(t1, t2);
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        clickOutsideDeactivates: true,
        fallbackFocus: () => rootElement.current,
        initialFocus: () => rootElement.current,
        ...options
      };
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== props) {
      t4 = <div ref={rootElement}><WrappedComponent {...props} /></div>;
      $[6] = props;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== isFocusTrapped || $[9] !== t4) {
      t5 = <FocusTrap active={isFocusTrapped} focusTrapOptions={t3}>{t4}</FocusTrap>;
      $[8] = isFocusTrapped;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  WithFocusTrap.displayName = `WithFocusTrap${WrappedComponent.displayName || WrappedComponent.name}`;
  return WithFocusTrap;
};
export default withFocusTrap;